export default __webpack_public_path__ + "static/media/shutterstock_1303746388.f75dc77d.png";